export default __webpack_public_path__ + "static/media/ic-chat-pubnub.6f980f3b.svg";